import { FilmIcon, ShareIcon } from '@heroicons/react/24/outline';
import { useRef } from 'react';
import { DateOfBirthDateOfDeath } from '../../../../Components/DateOfBirthDateOfDeath';
import { StreamingNow } from '../../../../Components/StreamingNow';
import { ShareMenuModal } from '../../Shared/ShareMenu';

export const Header = ({ service, shareUrl, isLive }) => {
  const shareModalRef = useRef<{
    share: () => {};
  }>(null);

  return (
    <>
      <ShareMenuModal shareModalRef={shareModalRef} service={{ service, share_url: shareUrl }} />
      <div className="header-container">
        <div>
          <h2 className="service-title">
            {service.serviceName.map((formatted) =>
              formatted?.key ? (
                <span key={formatted?.key} className={'service-title-' + formatted?.key}>
                  {formatted?.text}
                </span>
              ) : null,
            )}
          </h2>
          <DateOfBirthDateOfDeath dateOfBirth={service?.date_of_birth} dateOfDeath={service?.date_of_death} format={service.date_format} />
        </div>

        <div className="header-right-side-container">
          {isLive && <StreamingNow />}
          {/*@ts-ignore*/}
          {service?.videos?.length > 0 ? (
            <button
              onClick={(e) => {
                const videosContainer = ((e.target as HTMLButtonElement).getRootNode() as ShadowRoot).getElementById('videos-container');
                if (videosContainer) {
                  const rect = videosContainer.getBoundingClientRect();
                  window.scrollBy({
                    top: rect.top - window.innerHeight / 2, // replace 'x' with the number of pixels you want to offset
                    behavior: 'smooth',
                  });
                }
              }}
              className="view-videos-link-container"
            >
              <FilmIcon className="film-icon" />
              <span className="view-videos-link">View Videos</span>
            </button>
          ) : null}

          <button
            className="plain-button"
            onClick={() => {
              if (shareModalRef?.current) {
                shareModalRef?.current.share();
              }
            }}
          >
            <ShareIcon className="share-icon" />
          </button>
        </div>
      </div>
    </>
  );
};
